define('collections/commons/us-states',[
    "jquery",
    "underscore",
    "backbone",
    // models
    "models/commons/province",
    // datafiles
    "text!assets/datafiles/us-states.json",
], function ($, _, Backbone, MProvince, USStatesData) {
    var data = $.parseJSON(USStatesData);

    var CUSStates = Backbone.Collection.extend({
        url: "assets/datafiles/us-states.json",
        model: MProvince,
        initialize: function () {
            this.set(data, { silent: true });
        },
    });

    return CUSStates;
});

